import { defineComponent as _defineComponent } from 'vue'
import SvgIcon from './SvgIcon.vue';
import { useBasicStore } from '../../../stores/basic';
import ArrowStrokeBackIcon from '../icons/ArrowStrokeBackIcon.vue';
import '../../../directives/vTap';

interface Props {
  title: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PopUpH5',
  props: {
    title: null
  },
  setup(__props: any) {



const basicStore = useBasicStore();

function handleClose() {
  basicStore.setSidebarOpenStatus(false);
  basicStore.setSidebarName('');
}

return { __sfc: true,basicStore, handleClose, SvgIcon, ArrowStrokeBackIcon }
}

})